import { useApi, createApiHook } from "../utils/apiUtils";

const useReactivateAssignapp = () => {
  const { apiPatch } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const reactivateAssignapp = async ({ assignappId, reactivated }) => {
    startLoading();
    const response = await apiPatch(`/assignapps/${assignappId}/reactivate_assignapp`, "Error al reactivar o bloquear la asignación", {
      reactivated,
    });
    setResponse(response);

    return !response?.error;
  };

  return { reactivateAssignapp, data, error, loading };
};

export default useReactivateAssignapp;
